import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenBundleCarouselItemComponent } from "./bundle-carousel-item/bundle-carousel-item.component";
import { GenBundleCornerItemComponent } from "./bundle-corner-item/bundle-corner-item.component";
import { GenBundleSlideComponent } from "./bundle-slide.component";
import { RouterModule } from "@angular/router";
import { I18nModule, provideConfig, TranslationChunksConfig, UrlModule } from "@spartacus/core";
import { IconModule, MediaModule, SpinnerModule } from "@spartacus/storefront";
import { translationChunksConfig, translationsEn } from "@spartacus/assets";
import { GenMessageComponent } from '../message/message.component';
import { GenInfoMessageComponent } from '../info-message/info-message.component';

export const productTranslationChunksConfig: TranslationChunksConfig = {
  product: [
    ...translationChunksConfig.product,
    'bundle'
  ],
};

@NgModule({
  declarations: [
    GenBundleSlideComponent,
    GenBundleCarouselItemComponent,
    GenBundleCornerItemComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    I18nModule,
    IconModule,
    GenInfoMessageComponent,
    UrlModule,
    GenMessageComponent,
    MediaModule,
    SpinnerModule
  ],
  exports: [
    GenBundleSlideComponent
  ],
  providers:[
    provideConfig({
      i18n: {
        resources: { en: translationsEn },
        chunks: productTranslationChunksConfig
      }
    })
  ]
})
export class BundleSlideModule { }
